import React from 'react';
import { motion } from 'framer-motion';
import { FiFlag } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

function HoleCountToggle({ holeCount, onHoleCountChange, disabled = false, className = "" }) {
  const options = [
    { count: 9,  label: '9 Holes',  sub: '2 hrs' },
    { count: 18, label: '18 Holes', sub: '4 hrs' },
  ];

  return (
    <div className={className}>
      <label className="block text-sm font-semibold text-text-secondary mb-3">
        <SafeIcon icon={FiFlag} className="w-4 h-4 inline mr-2" />
        Number of Holes
      </label>

      <div className="grid grid-cols-2 gap-2 sm:gap-4">
        {options.map(({ count, label, sub }) => {
          const selected = holeCount === count;
          return (
            <motion.button
              key={count}
              type="button"
              whileHover={{ scale: disabled ? 1 : 1.02 }}
              whileTap={{ scale: disabled ? 1 : 0.98 }}
              onClick={() => !disabled && onHoleCountChange?.(count)}
              disabled={disabled}
              className={`p-3 sm:p-4 rounded-xl border-2 transition-all duration-200 flex items-center justify-center min-h-[80px] sm:min-h-[100px] bg-card ${
                selected ? 'border-accent' : 'border-border-subtle'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            >
              <div className="flex flex-col sm:flex-row items-center w-full sm:items-center">
                <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-xl flex items-center justify-center sm:mr-3 mb-1 sm:mb-0 flex-shrink-0 ${
                  selected ? 'bg-accent' : 'bg-surface'
                }`}>
                  <SafeIcon icon={FiFlag} className={`w-4 h-4 sm:w-5 sm:h-5 ${selected ? 'text-white' : 'text-text-muted'}`} />
                </div>
                <div className="flex-1 text-center sm:text-left">
                  <h5 className={`text-sm sm:text-base font-bold ${selected ? 'text-accent' : 'text-text-primary'}`}>
                    {label}
                  </h5>
                  <p className="text-xs text-text-secondary">{sub}</p>
                </div>
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}

export default HoleCountToggle;
